import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { PosterClickEventPayload } from '@/components/timeline/types';
import type { ModuleTitleFieldsFragment } from '@/features/onboarded-home/graphql/queries/GetHomeModules.query';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import HorizontalTitleList from '@/components/timeline/HorizontalTitleList.vue';
import { CollectionType } from '@/enums/collection-type';

import { calculateUrl } from '@/helpers/state-helper';

import { useRouter } from 'vue-router/composables';
import { useConstantStore } from '@/helpers/composables/useStores';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewOnYourServicesTitleList',
  props: {
    titles: null,
    totalCount: null,
    providerShortName: null,
    additionalContexts: { default: () => [] }
  },
  emits: ["titleClicked", "newOnYourServiceClick"],
  setup(__props: any) {

const props = __props as { titles: ModuleTitleFieldsFragment[], totalCount: number, providerShortName: string, additionalContexts: SnowplowContext[] };





const { providersByShortName } = useConstantStore();
const router = useRouter();

const moreTitlesUrl = computed(() =>
	calculateUrl(
		router,
		undefined,
		CollectionType.NEW,
		{ providers: [props.providerShortName] },
		providersByShortName.value
	)
);

return { __sfc: true,props, providersByShortName, router, moreTitlesUrl, ProviderIcon, HorizontalTitleList }
}

})